import {
  COMMON,
  translationUrl,
  VDS_KEY,
  VERSION,
  CANCEL_SUBSCRIPTION,
} from "../../constants/ApiUrls";
import {
  getData,
  deleteData,
  postData,
} from "../../networkManager/NetworkManager";

export const getTranslations = async (key) => {
  return await getData(
    VDS_KEY + VERSION + `${translationUrl.TRANSLATION}?language=${key}`
  );
};
export const offBoardUser = async (key) => {
  return await postData(VDS_KEY + VERSION + `user/${CANCEL_SUBSCRIPTION}`);
};
